import { render, staticRenderFns } from "./statement-details.vue?vue&type=template&id=31897ff0"
import script from "./statement-details.vue?vue&type=script&lang=js"
export * from "./statement-details.vue?vue&type=script&lang=js"
import style0 from "./statement-details.vue?vue&type=style&index=0&id=31897ff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports